import { SVGProps } from "react";

export const IconCog = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            opacity="0.65"
            d="M0 9.63847C0 8.77397 0.1097 7.93507 0.31595 7.13498C1.40622 7.1915 2.48848 6.64882 3.0718 5.63849C3.65467 4.62892 3.58406 3.42138 2.99121 2.50568C4.18354 1.33396 5.66832 0.45889 7.32603 0C7.8222 0.97252 8.8333 1.63849 10 1.63849C11.1667 1.63849 12.1778 0.97252 12.674 0C14.3317 0.45889 15.8165 1.33396 17.0088 2.50568C16.4159 3.42138 16.3453 4.62892 16.9282 5.63849C17.5115 6.64882 18.5938 7.1915 19.6841 7.13498C19.8903 7.93507 20 8.77397 20 9.63847C20 10.503 19.8903 11.3419 19.6841 12.142C18.5938 12.0855 17.5115 12.6282 16.9282 13.6385C16.3453 14.6481 16.4159 15.8556 17.0088 16.7713C15.8165 17.943 14.3317 18.8181 12.674 19.277C12.1778 18.3045 11.1667 17.6385 10 17.6385C8.8333 17.6385 7.8222 18.3045 7.32603 19.277C5.66832 18.8181 4.18354 17.943 2.99121 16.7713C3.58406 15.8556 3.65467 14.6481 3.0718 13.6385C2.48848 12.6282 1.40622 12.0855 0.31595 12.142C0.1097 11.3419 0 10.503 0 9.63847ZM4.80385 12.6385C5.43395 13.7299 5.61458 14.9846 5.36818 16.1623C5.77597 16.4525 6.21005 16.7039 6.66489 16.9128C7.56176 16.1099 8.7392 15.6385 10 15.6385C11.2608 15.6385 12.4382 16.1099 13.3351 16.9128C13.7899 16.7039 14.224 16.4525 14.6318 16.1623C14.3854 14.9846 14.566 13.7299 15.1962 12.6385C15.8262 11.5472 16.8225 10.7635 17.9655 10.388C17.9884 10.1402 18 9.89027 18 9.63847C18 9.38677 17.9884 9.13677 17.9655 8.88907C16.8225 8.51357 15.8262 7.72987 15.1962 6.63849C14.566 5.54712 14.3854 4.29245 14.6318 3.11472C14.224 2.82455 13.7899 2.57314 13.3351 2.36419C12.4382 3.16711 11.2608 3.63849 10 3.63849C8.7392 3.63849 7.56176 3.16711 6.66489 2.36419C6.21005 2.57314 5.77597 2.82455 5.36818 3.11472C5.61458 4.29245 5.43395 5.54712 4.80385 6.63849C4.17376 7.72987 3.17754 8.51357 2.03451 8.88907C2.01157 9.13677 2 9.38677 2 9.63847C2 9.89027 2.01157 10.1402 2.03451 10.388C3.17754 10.7635 4.17376 11.5472 4.80385 12.6385ZM10 12.6385C8.3431 12.6385 7 11.2954 7 9.63847C7 7.98167 8.3431 6.63849 10 6.63849C11.6569 6.63849 13 7.98167 13 9.63847C13 11.2954 11.6569 12.6385 10 12.6385ZM10 10.6385C10.5523 10.6385 11 10.1908 11 9.63847C11 9.08617 10.5523 8.63847 10 8.63847C9.4477 8.63847 9 9.08617 9 9.63847C9 10.1908 9.4477 10.6385 10 10.6385Z"
            fill="black"
        />
    </svg>
);

export const IconUser = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="16"
        height="21"
        viewBox="0 0 16 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            opacity="0.65"
            d="M0 21C0 16.5817 3.58172 13 8 13C12.4183 13 16 16.5817 16 21H14C14 17.6863 11.3137 15 8 15C4.68629 15 2 17.6863 2 21H0ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12ZM8 10C10.21 10 12 8.21 12 6C12 3.79 10.21 2 8 2C5.79 2 4 3.79 4 6C4 8.21 5.79 10 8 10Z"
            fill="black"
        />
    </svg>
);

export const IconPen = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2 15.9706H3.41421L12.7279 6.65686L11.3137 5.24264L2 14.5564V15.9706ZM18 17.9706H0V13.728L13.435 0.292897C13.8256 -0.0976325 14.4587 -0.0976325 14.8492 0.292897L17.6777 3.12132C18.0682 3.51185 18.0682 4.14501 17.6777 4.53554L6.24264 15.9706H18V17.9706ZM12.7279 3.82843L14.1421 5.24264L15.5563 3.82843L14.1421 2.41422L12.7279 3.82843Z"
            fill="#333333"
        />
    </svg>
);

export const IconCheckedCircle = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7 14C3.134 14 0 10.866 0 7C0 3.134 3.134 0 7 0C10.866 0 14 3.134 14 7C14 10.866 10.866 14 7 14ZM7 12.6C10.0928 12.6 12.6 10.0928 12.6 7C12.6 3.9072 10.0928 1.4 7 1.4C3.9072 1.4 1.4 3.9072 1.4 7C1.4 10.0928 3.9072 12.6 7 12.6ZM6.30182 9.8L3.33199 6.83018L4.32195 5.84017L6.30182 7.82012L10.2617 3.8603L11.2516 4.85025L6.30182 9.8Z"
            fill="black"
        />
    </svg>
);
